import type { InterventionTemplateLite } from "@/entities/intervention-template";
import type { UseListOptions } from "@/hooks/queries";

import { useList } from "@/hooks/queries";

export const useGetInterventionTemplates = (
  options?: UseListOptions<InterventionTemplateLite>
) => {
  const { data, ...queryResult } = useList<InterventionTemplateLite>(
    "interventionTemplates",
    options
  );

  return {
    interventionTemplates: data?.data ?? [],
    ...queryResult,
  };
};
